import { CopyButton } from './copy-button';
import { useDebugToolPosVendor } from './use-debug-tool-pos-vendor';

export const StoreInfo = () => {
  const { storeNumber, storeLabel } = useDebugToolPosVendor();
  return <CopyButton label={storeLabel} textToCopy={storeNumber} variant="headerTwo" />;
};
